import type { IconData } from '@stacksjs/iconify-core'

export const smileyIndiferent: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M45 24c0 11.598-9.402 21-21 21S3 35.598 3 24S12.402 3 24 3s21 9.402 21 21Z\"/><path stroke-linecap=\"round\" d=\"M16 32h16M13 18h6m10 0h6\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default smileyIndiferent
